import { MainSignupSection } from 'src/v2/pages/auth/components/MainSignupSection/MainSignupSection';
import { isEnterprise } from 'src/utils';
// Email signup functionality commented out - enforcing SSO-only signup
// import { MainEmailSignupSection } from 'src/v2/pages/auth/components/MainEmailSignupSection';
import { EnterpriseMeetNinjaSection } from 'src/v2/pages/auth/components/MeetNinjaSection';
import { SEO_SIGN_UP_DESCRIPTION, SEO_SIGN_UP_TITLE } from 'src/constants';
import { BaseSignPage } from '../BaseSignPage/BaseSignPage';
import { BasePublicPage } from 'src/v2/pages/auth/BasePublicPage';

export const SignupPage = () => {
  return isEnterprise ? (
    <BasePublicPage
      seoTitle={SEO_SIGN_UP_TITLE}
      seoDescription={SEO_SIGN_UP_DESCRIPTION}
    >
      <EnterpriseMeetNinjaSection />
      {/* Email signup functionality commented out - enforcing SSO-only signup */}
      {/* <MainEmailSignupSection /> */}
      <MainSignupSection />
    </BasePublicPage>
  ) : (
    <BaseSignPage
      seoTitle={SEO_SIGN_UP_TITLE}
      seoDescription={SEO_SIGN_UP_DESCRIPTION}
    >
      <MainSignupSection />
    </BaseSignPage>
  );
};
